import UserConsentShow from './Show'
import UserConsentList from './List'
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip'

export default {
    icon: PrivacyTipIcon,
    list: UserConsentList,
    show: UserConsentShow
}